module.exports = __webpack_public_path__ + "img/paint-brush-solid updated.61496e4c.svg";